var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHotel = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 11.6666C7.21683 11.6666 8.3335 10.55 8.3335 9.16663C8.3335 7.78329 7.21683 6.66663 5.8335 6.66663C4.45016 6.66663 3.3335 7.78329 3.3335 9.16663C3.3335 10.55 4.45016 11.6666 5.8335 11.6666ZM5.8335 8.33329C6.29183 8.33329 6.66683 8.70829 6.66683 9.16663C6.66683 9.62496 6.29183 9.99996 5.8335 9.99996C5.37516 9.99996 5.00016 9.62496 5.00016 9.16663C5.00016 8.70829 5.37516 8.33329 5.8335 8.33329ZM15.8335 5.83329H9.16683V12.5H2.50016V4.16663H0.833496V16.6666H2.50016V14.1666H17.5002V16.6666H19.1668V9.16663C19.1668 7.32496 17.6752 5.83329 15.8335 5.83329ZM17.5002 12.5H10.8335V7.49996H15.8335C16.7502 7.49996 17.5002 8.24996 17.5002 9.16663V12.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHotel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hotel.02518fb7.svg";
export { ForwardRef as ReactComponent };